import { render, staticRenderFns } from "./versionPage.vue?vue&type=template&id=6893a874&scoped=true&"
import script from "./versionPage.vue?vue&type=script&lang=js&"
export * from "./versionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893a874",
  null
  
)

export default component.exports